import moment from 'moment';
import app from '../../../app';
import {
  and,
  or,
  questionIsNo,
  questionIsYes,
  visitNumberIs,
  questionIs,
  meanBloodPressureAboveGoal,
  numberOfAntiHypertensiveDrugsIncludes,
  hadPCIAfter,
  not,
  CHA2DS2VASCGenderIndependentGreaterThan,
  visit2OrVisit6And2Skipped
} from "./question-conditions";

const sixMonthsAgo = moment().subtract(6, 'months')

const whenCurrentVersionIsLessThan6 = () => app.store.getters['encounter/versionInt'] < 6

const medicationDSS = [
  {
    key: 'MYOCARDIAL_INFARCTION_12MONTHS',
    display: visitNumberIs(2,6),
    post: visitNumberIs(2,6),
  },
  {
    key: 'STEMI_NSTEMI',
    display: and(
        visitNumberIs(2,6),
        questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS')
    ),
    post: visitNumberIs(2,6),
  },
  {
    key: 'HISTORY_ATRIAL_FIBRILLATION',
    display: and(
        visitNumberIs(6),
        or(
            questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS'),
            and(
                questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIs('STEMI_NSTEMI', 'NSTEMI'),
            ),
            and(
                questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIs('STEMI_NSTEMI', 'STEMI'),
            )
        )
    ),
    post: visitNumberIs(6),
  },
  {
    key: 'SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION',
    display: and(
        visitNumberIs(6),
        or(
            questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS'),
            and(
                questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIs('STEMI_NSTEMI', 'NSTEMI')
            ),
            and(
                questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIs('STEMI_NSTEMI', 'STEMI')
            )
        )
    ),
    post: visitNumberIs(6),
  },
  {
    key: 'PULMONARY_OR_SYSTEMIC_CONGESTION',
    display: and(
        visitNumberIs(2,6),
        or(
            and(
                questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIsYes('SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION', whenCurrentVersionIsLessThan6),
            ),
            and(
                questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIs('STEMI_NSTEMI', 'NSTEMI'),
                questionIsYes('SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION', whenCurrentVersionIsLessThan6),
            ),
            and(
                questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIs('STEMI_NSTEMI', 'STEMI'),
                questionIsYes('SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION', whenCurrentVersionIsLessThan6),
            ),
        )
    ),
    post: visitNumberIs(2,6),
  },
  {
    key: 'EFFORT_ANGINA',
    display: and(
        visitNumberIs(2,6),
        questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS')
    ),
    post: visitNumberIs(2,6),
  },
  {
    key: 'ANGINA_PECTORIS_IN_REST',
    display: and(
        visitNumberIs(2,6),
        or(
            questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS'),
            and(
                meanBloodPressureAboveGoal,
                numberOfAntiHypertensiveDrugsIncludes(2,3)
            ),
            and(
                meanBloodPressureAboveGoal,
                numberOfAntiHypertensiveDrugsIncludes(0,1),
                questionIsNo('HISTORY_MI', whenCurrentVersionIsLessThan6),
            )
        )
    ),
    post: visitNumberIs(2,6),
  },
  {
    key: 'IS_SYMPTOMATIC',
    display: and(
        visitNumberIs(2,6),
        and(
            questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS'),
            questionIsYes('SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION', whenCurrentVersionIsLessThan6),
        ),
    ),
    post: visitNumberIs(2,6),
  },
  {
    key: 'HAS_HYPERKALAEMIA',
    display: and(
        visitNumberIs(2,6),
        questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
        questionIs('STEMI_NSTEMI', 'STEMI'),
        questionIsYes('SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION', whenCurrentVersionIsLessThan6),
    ),
    post: visitNumberIs(2,6),
  },
  {
    key: 'ANTERIOR_INFARCTION',
    display: and(
        visitNumberIs(2,6),
        questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
        questionIs('STEMI_NSTEMI', 'STEMI'),
        questionIsNo('SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION', whenCurrentVersionIsLessThan6),
    ),
    post: visitNumberIs(2,6),
  },
  {
    key: 'RISK_GASTRO_INTESTINAL_BLEEDING',
    display: and(
        visitNumberIs(2,6),
        or(
            and(
                questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIs('STEMI_NSTEMI', 'NSTEMI'),
            ),
            and(
                questionIsYes('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIs('STEMI_NSTEMI', 'STEMI'),
            ),
            and(
                questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIsNo('HISTORY_ATRIAL_FIBRILLATION', whenCurrentVersionIsLessThan6),
                hadPCIAfter(sixMonthsAgo, whenCurrentVersionIsLessThan6)
            ),
            and(
                questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIsYes('HISTORY_ATRIAL_FIBRILLATION', whenCurrentVersionIsLessThan6),
                hadPCIAfter(sixMonthsAgo, whenCurrentVersionIsLessThan6)
            ),
            and(
                questionIsNo('MYOCARDIAL_INFARCTION_12MONTHS'),
                questionIsYes('HISTORY_ATRIAL_FIBRILLATION', whenCurrentVersionIsLessThan6),
                not(hadPCIAfter(sixMonthsAgo, whenCurrentVersionIsLessThan6)),
                CHA2DS2VASCGenderIndependentGreaterThan(1)
            )
        )
    ),
    post: visitNumberIs(2,6),
  },
  {
    key: 'HISTORY_MI',
    display: and(
        visitNumberIs(6),
        meanBloodPressureAboveGoal,
        numberOfAntiHypertensiveDrugsIncludes(0,1,2,3)
    ),
    post: visitNumberIs(6),
  },
  {
    key: 'HAD_PCI',
    display: visitNumberIs(6),
    post: visitNumberIs(6),
  },
  {
    key: 'PCI_DATE',
    display: and(
        visitNumberIs(6),
        questionIsYes('HAD_PCI')
    ),
    post: visitNumberIs(6),
  },
  {
    key: 'SECOND_VASCULAR_EVENT_2YEARS_ON_STATIN',
    display: visitNumberIs(2,6),
    post: visitNumberIs(2,6),
  },
  {
    key: 'ALREADY_HIGH_DOSE_STATIN',
    display: visitNumberIs(2,6),
    post: visitNumberIs(2,6),
  },
  {
    key: 'ACEI_INTOLERANCE',
    display: visit2OrVisit6And2Skipped,
    post: visit2OrVisit6And2Skipped,
  },
  {
    key: 'INTOLERANCE_ASPIRIN',
    display: visit2OrVisit6And2Skipped,
    post: visit2OrVisit6And2Skipped,
  },
];

export default medicationDSS;